import { CruiseApi, TripApi, TrackApi, ApiClient, ICruiseResponse, ITracksResponse, ITripsResponse } from "../../Types"

export const CruiseViewData = {
  loadCruise(api: ApiClient, shipId: number, cruiseId: number): Promise<ICruiseResponse> {
    return new CruiseApi(api).cruises.get({ params: { shipId, cruiseId } }).call();
  },
  loadTrips(api: ApiClient, shipId: number, cruiseId: number): Promise<ITripsResponse> {
    return new TripApi(api).trips.list({ params: { shipId, cruiseId } }).call();
  },
  loadTracks(api: ApiClient, shipId: number, cruiseId: number): Promise<ITracksResponse> {
    return new TrackApi(api).tracks.cruise({ params: { shipId, cruiseId } }).call();
  },
};
